/** Rutas con datos de cuenta: solo se muestran con sesión activa. */
export const SESSION_PRIVATE_PREFIXES = ["/admin", "/mi-cuenta", "/partner", "/seguridad"];
/** Rutas que el navegador nunca debe guardar en caché (incluye detalle de reservas). */
export const NO_STORE_PREFIXES = [...SESSION_PRIVATE_PREFIXES, "/reserva", "/reserva-prueba", "/auth"];

const LANG = /^\/(en|fr|it|de|pt)(?=\/|$)/;
const match = (pathname: string, list: string[]) => {
  const p = pathname.replace(LANG, "") || "/";
  return list.some((x) => p === x || p.startsWith(`${x}/`));
};
export const isSessionPrivatePath = (p: string) => match(p, SESSION_PRIVATE_PREFIXES);
export const isNoStorePath = (p: string) => match(p, NO_STORE_PREFIXES);
